import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../Config/Api";
import { RootState } from "../store";
import { ExtractErrorInfo } from "../../components/shared/ExtractErrorInfo";
import { FeatureFlag } from "../../types/featureFlagType";
import { AppType } from "types/appType";
import { API_ENDPOINTS } from "Config/apiConfig";

export interface AppTypeWithFeatureFlags extends AppType {
  loading: boolean;
  error: any | null;
  featureFlags: FeatureFlag[];
}

const initialState: AppTypeWithFeatureFlags = {
  loading: false,
  error: null,
  featureFlags: [],
};

// Thunk to fetch all feature flags
export const fetchFeatureFlags = createAsyncThunk<FeatureFlag[], void, { rejectValue: any }>(
  "featureFlags/fetchFeatureFlags",
  async (_, { rejectWithValue }) => {
    try {
      //  const response = await api.post<void>(`${API_ENDPOINTS.contacts(incidentId)}`, contact);
      const { data } = await api.get<FeatureFlag[]>(`${API_ENDPOINTS.featureFlags}`);
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    } catch (error: any) {
      const errorInfo = ExtractErrorInfo(error);
      return rejectWithValue(errorInfo);
    }
  }
);

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    clearFeatureFlags: (state) => {
      state.featureFlags = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFeatureFlags.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchFeatureFlags.fulfilled, (state, action) => {
      state.loading = false;
      state.featureFlags = action.payload;
    });
    builder.addCase(fetchFeatureFlags.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearFeatureFlags } = featureFlagsSlice.actions;
export const featureFlagsRootState = (state: RootState) => state.featureFlags;
export default featureFlagsSlice.reducer;
